import {
  AlertVariantEnum,
  alertInitialState,
  AlertModelAttributesEnum,
  reducerAlertMessage,
} from '@th-types/alert-model.type';
import { useEffect, useReducer, useCallback } from 'react';

export default function useAlert() {
  const [alertMessage, dispatch] = useReducer(
    reducerAlertMessage,
    alertInitialState
  );

  useEffect(() => {
    if (alertMessage.show) {
      setTimeout(() => {
        dispatch({ type: AlertModelAttributesEnum.SHOW, value: false });
      }, 5000);
    }
  }, [alertMessage]);

  const showMessage = useCallback((message: string) => {
    dispatch({ type: AlertModelAttributesEnum.MESSAGE, value: message });
    dispatch({ type: AlertModelAttributesEnum.SHOW, value: true });
  }, []);

  const showSuccessAlert = useCallback(
    (messageAlert: string) => {
      dispatch({
        type: AlertModelAttributesEnum.VARIANT,
        value: AlertVariantEnum.SUCCESS,
      });
      showMessage(messageAlert);
    },
    [showMessage]
  );

  const showWarningAlert = useCallback(
    (messageAlert: string) => {
      dispatch({
        type: AlertModelAttributesEnum.VARIANT,
        value: AlertVariantEnum.WARNING,
      });
      showMessage(messageAlert);
    },
    [showMessage]
  );

  const showErrorAlert = useCallback(
    (messageAlert: string) => {
      dispatch({
        type: AlertModelAttributesEnum.VARIANT,
        value: AlertVariantEnum.DANGER,
      });
      showMessage(messageAlert);
    },
    [showMessage]
  );

  return {
    showSuccessAlert,
    showWarningAlert,
    showErrorAlert,
    alertMessage,
  };
}
